import React from 'react'
import Navbar from '../components/navbar_poc'
import ShapeTwo from '../components/shape-two'
import bg1 from '../assets/images/bg.jpg'
import { Link } from 'react-router-dom'
import aboutImg from '../assets/images/meettheleaders.jpg'
import VideoModalTwo from '../components/video-modal-two'
import { featureData } from '../data/agency-data'
import ClientThree from '../components/client-three'
import clientImg from '../assets/images/client.png'
import Shape from '../components/shape'
import Footer from '../components/footer'
import SEO from '../components/seo'
import { teamOne } from '../data'
import VideoModalOne from '../components/video-modal-one'
export default function PageAbout() {
  return (
    <>
     <Navbar/> 
     <SEO
  title="About Pioneer One Global – Your Cross-Border India Partner"
  description="Meet the founders and team behind Pioneer One Global. Discover how decades of US-India experience power our unique approach to global expansion."
  url="https://www.pioneeroneglobal.com/about"
  image="https://www.pioneeroneglobal.com/images/og-about.jpg"
/>
    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay bg-overlay-white"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title">About Us</h4>
                          <p className="text-muted mb-0">Bridging Global Vision with Local Expertise</p>                                        
                      </div>
                  </div>
              </div>

              <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                  <div className="page-next-level text-sm-end">
                      <ul className="page-next ps-0 mb-0">
                          <li className="list-inline-item"><Link to="/" className="text-uppercase fw-bold text-dark">Home</Link></li>
                          {/* <li className="list-inline-item"><Link to="#" className="text-uppercase fw-bold text-dark">Pages</Link></li> */}
                          <li className="list-inline-item">
                              <span className="text-uppercase text-primary fw-bold">About Us</span> 
                          </li> 
                      </ul>
                  </div>
              </div>
          </div>
      </div> 
    </section>

    <ShapeTwo/>

    <section className="section"> 
      <div className="container">
          <div className="row align-items-center">
              <div className="col-md-6">
                  <div className="position-relative">
                      <img src={aboutImg} className="img-fluid shadow rounded" alt=""/>
                      <VideoModalOne/>
                  </div>
              </div>

              <div className="col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="section-title ms-md-4">
                      <h4 className="title mb-4">Who We Are</h4>
                      <p className="text-muted">Pioneer One Global is a cross-border business launchpad co-created by Pioneer One LLP (India) and Minmini (U.S.). Together, we bring a combined 20+ years of legal, compliance, finance, technology, and AI execution experience.</p>
                      <p className="text-muted">Our mission is to make India accessible, navigable, and profitable for global companies by combining human expertise with intelligent automation.</p>
                      <Link to="/contact" className="btn btn-outline-primary mt-2"><i className="mdi mdi-phone"></i> Contact Us</Link>
                  </div>
              </div>
          </div>
      </div>
    <div className="container mt-100 mt-60">
          <div className="row">
              <div className="col-12 text-center">
                  <div className="section-title mb-4 pb-2">
                      <h4 className="title mb-4">Leadership</h4>
                    </div>
              </div>
          </div>

          <div className="row">
            {teamOne.slice(0,4).map((item,index)=>{
              return(
                  <div className="col-md-6 col-12 mt-4 pt-2" key={index}>
                      <div className="team-list position-relative overflow-hidden shadow rounded">
                          <img height="100" src={item.image} className="img-fluid float-start" alt=""/>
                          <div className="content float-end p-4">
                              <h5 className="title mb-0">{item.name}</h5>
                              <small className="text-muted">{item.position}</small><br/>
                              <small className="text-muted">{item.position2}</small>
                              <p className="text-muted mt-3">{item.description}</p>
                              <ul className="list-unstyled follow social-icon social mb-0">
                                {item.social.map((el,index)=>{
                                  return(
                                      <li className="list-inline-item m-x-2" key={index}><Link to={el.link} className="rounded"><i className={el.icon}></i></Link></li>
                                  )
                                })}
                              </ul>
                          </div>
                      </div>                        
                  </div>
              )
            })}
          </div>
      </div>
    </section>
    <Shape/>
    <Footer/>
    </>
  )
}
